import {BaseCachedService} from './Core/BaseCachedService';

class SampleEventTypeService extends BaseCachedService {
    get Url() { return super.Url + "/sampleEventTypes"; }
    get ModelName() { return "SampleEventType"; }
    get PrimaryKeyProperty() { return "sampleEventTypeId"; }
}

export const service = new SampleEventTypeService();

